import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Paper,
  makeStyles
} from "@material-ui/core";
import { DeleteOutline, Edit } from "@material-ui/icons";
import { TwitterPicker } from "react-color";
import api from "../../services/api";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 400,
  },
  colorPicker: {
    margin: theme.spacing(2, 0),
  }
}));

const LabelsManager = ({ open, onClose }) => {
  const classes = useStyles();
  const [labels, setLabels] = useState([]);
  const [editingLabel, setEditingLabel] = useState(null);
  const [name, setName] = useState("");
  const [color, setColor] = useState("#000000");

  useEffect(() => {
    if (open) loadLabels();
  }, [open]);

  const loadLabels = async () => {
    try {
      const { data } = await api.get("/labels");
      setLabels(data);
    } catch (e) {
      toast.error("Error al cargar etiquetas");
    }
  };

  const handleSave = async () => {
    try {
      if (editingLabel) {
        await api.put(`/labels/${editingLabel.id}`, { name, color });
        toast.success("Etiqueta actualizada");
      } else {
        await api.post("/labels", { name, color });
        toast.success("Etiqueta creada");
      }
      loadLabels();
      setName("");
      setColor("#000000");
      setEditingLabel(null);
    } catch (e) {
      toast.error("Error al guardar etiqueta");
    }
  };

  const handleEdit = (label) => {
    setEditingLabel(label);
    setName(label.name);
    setColor(label.color);
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/labels/${id}`);
      toast.success("Etiqueta eliminada");
      loadLabels();
    } catch (e) {
      toast.error("Error al eliminar etiqueta");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Gestionar Etiquetas</DialogTitle>
      <DialogContent>
        <Paper variant="outlined" style={{ padding: 16, marginBottom: 16 }}>
            <TextField
              label="Nombre"
              value={name}
              onChange={(e) => setName(e.target.value)}
              fullWidth
              variant="outlined"
              margin="dense"
            />
            <div className={classes.colorPicker}>
                <TwitterPicker 
                    color={color} 
                    onChangeComplete={(c) => setColor(c.hex)} 
                />
            </div>
            <Button 
                variant="contained" 
                color="primary" 
                onClick={handleSave}
                disabled={!name}
            >
                {editingLabel ? "Actualizar" : "Crear"}
            </Button>
            {editingLabel && (
                <Button 
                    onClick={() => {
                        setEditingLabel(null);
                        setName("");
                        setColor("#000000");
                    }}
                    style={{ marginLeft: 8 }}
                >
                    Cancelar Edición
                </Button>
            )}
        </Paper>

        <Table className={classes.table} size="small">
          <TableHead>
            <TableRow>
              <TableCell>Nombre</TableCell>
              <TableCell>Color</TableCell>
              <TableCell align="right">Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {labels.map((label) => (
              <TableRow key={label.id}>
                <TableCell>{label.name}</TableCell>
                <TableCell>
                    <div style={{ width: 20, height: 20, backgroundColor: label.color, borderRadius: '50%' }} />
                </TableCell>
                <TableCell align="right">
                  <IconButton size="small" onClick={() => handleEdit(label)}>
                    <Edit />
                  </IconButton>
                  <IconButton size="small" onClick={() => handleDelete(label.id)}>
                    <DeleteOutline />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LabelsManager;
